import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_APPRENTICE_COPY_CAMPAIGN,
    API_APPRENTICE_CREATE_CAMPAIGN,
    API_APPRENTICE_DELETE_CAMPAIGN,
    API_APPRENTICE_GET_BRAND_CAMPAIGNs,
    API_APPRENTICE_GET_SNAPSHOT_CAMPAIGNS,
    API_APPRENTICE_UPDATE_CAMPAIGN,
    API_APPRENTICE_WRITE_CAMPAIGN,
    API_NEW_USER_CAMPAIGN,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import {
    ICampaignDetails,
    ICopyCampaign,
    ICreateCampaignRequestPayload,
    IDeleteCampaignRequestPayload,
    IUpdateCampaignRequestPayload,
    IWriteCampaignRequestPayload,
    IWriteCampaignResponse,
} from '../../interfaces/campaign.interface';

export const campaignApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            writeCampaign: builder.mutation<IWriteCampaignResponse, IWriteCampaignRequestPayload>({
                query: (data) => ({
                    url: API_APPRENTICE_WRITE_CAMPAIGN,
                    method: HTTP_METHODS.POST,
                    body: data,
                }),
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            createCampaign: builder.mutation<ICampaignDetails, ICreateCampaignRequestPayload>({
                query: (data) => ({
                    url: API_APPRENTICE_CREATE_CAMPAIGN,
                    method: HTTP_METHODS.POST,
                    body: data,
                }),
                invalidatesTags: ['brandCampaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            updateCampaign: builder.mutation<ICampaignDetails, IUpdateCampaignRequestPayload>({
                query: (data) => ({
                    url: API_APPRENTICE_UPDATE_CAMPAIGN,
                    method: HTTP_METHODS.PATCH,
                    body: data,
                }),
                invalidatesTags: ['brandCampaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            deleteCampaign: builder.mutation<boolean, IDeleteCampaignRequestPayload>({
                query: (data) => ({
                    url: API_APPRENTICE_DELETE_CAMPAIGN,
                    method: HTTP_METHODS.DELETE,
                    body: data,
                }),
                invalidatesTags: ['brandCampaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getBrandCampaigns: builder.query<ICampaignDetails[], number>({
                query: (brandId) => ({
                    url: `${API_APPRENTICE_GET_BRAND_CAMPAIGNs}/?brandId=${brandId}`,
                    method: HTTP_METHODS.GET,
                }),
                providesTags: ['brandCampaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
            getNewUserCampaign: builder.query<ICampaignDetails, number>({
                query: (brandId) => ({
                    url: `${API_NEW_USER_CAMPAIGN}?brandId=${brandId}`,
                    method: HTTP_METHODS.GET,
                }),
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
            getSnapshotCampaign: builder.query<ICampaignDetails, string>({
                query: (sessionId) => ({
                    url: `${API_APPRENTICE_GET_SNAPSHOT_CAMPAIGNS}/?sessionId=${sessionId}`,
                    method: HTTP_METHODS.GET,
                }),
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
            copyCampaign: builder.mutation<ICampaignDetails, ICopyCampaign>({
                query: (data) => ({
                    url: `${API_APPRENTICE_COPY_CAMPAIGN}?campaignId=${data.campaignId}&brandId=${data.brandId}`,
                    method: HTTP_METHODS.POST,
                }),
                invalidatesTags: ['brandCampaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const {
    useWriteCampaignMutation,
    useCreateCampaignMutation,
    useUpdateCampaignMutation,
    useDeleteCampaignMutation,
    useLazyGetBrandCampaignsQuery,
    useLazyGetSnapshotCampaignQuery,
    useLazyGetNewUserCampaignQuery,
    useCopyCampaignMutation,
} = campaignApiSlice;
